export default "__VITE_ASSET__IckOXt_O__"